<div fxLayout="row" fxLayoutAlign="start center">
    <mat-icon>{{ statusMessage?.icone }}</mat-icon>
    <div class="mensagem-usuario">{{ statusMessage?.mensagemUsuario }}</div>
</div>
